/* GET ZIP_TIERS */
export const GET_ZIP_TIERS = "GET_ZIP_TIERS"
export const GET_ZIP_TIERS_SUCCESS = "GET_ZIP_TIERS_SUCCESS"
export const GET_ZIP_TIERS_ERROR = "GET_ZIP_TIERS_ERROR"

/*CREATE ZIP_TIER */
export const CREATE_NEW_GET_ZIP_TIER= "CREATE_NEW_GET_ZIP_TIER"
export const NEW_ZIP_TIER_SUCCESS = "NEW_ZIP_TIER_SUCCESS"
export const NEW_ZIP_TIER_ERROR = "NEW_ZIP_TIER_ERROR"

/*MODIFY AD */
export const MODIFY_ZIP_TIER = "MODIFY_ZIP_TIER"
export const MODIFY_ZIP_TIER_SUCCESS = "MODIFY_ZIP_TIER_SUCCESS"
export const MODIFY_ZIP_TIER_ERROR = "MODIFY_ZIP_TIER_ERROR"

/*DELETE ZIP_TIER */
export const DELETE_ZIP_TIER = "DELETE_ZIP_TIER"
export const DELETE_ZIP_TIER_SUCCESS = "DELETE_ZIP_TIER_SUCCESS"
export const DELETE_ZIP_TIER_ERROR = "DELETE_ZIP_TIER_ERROR"
